import { useTranslation } from 'react-i18next';
import { QueryHookOptions } from '@apollo/client';
import { SelectOption } from '@anytag/shared-types';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, QueryallProvincesArgs, useAllProvincesQuery } from '@anytag/graphql';

export const useAllProvinceOptions = (props: QueryHookOptions<Query, QueryallProvincesArgs> = {}) => {
  const { t } = useTranslation();
  const { data, loading } = useAllProvincesQuery(props);

  const options = getSelectOptions(data?.allProvinces);

  return {
    loading,
    allProvinceOptions: options.map<SelectOption<string>>((option) => ({
      ...option,
      label: t<string>(option.label || '')
    }))
  };
};
